<div class="wrapper">
    <router-outlet (activate)="onActivate($event, outlet)" #outlet></router-outlet>

</div>